import React, { useEffect } from 'react';
import * as intercom from '../../lib/intercom';

const LiveChat = ({ darkFooter, data }) => {
  useEffect(() => {
    intercom.boot();
  }, []);

  return <>{intercom.oldScript()}</>;
};

export default LiveChat;
